<form-generator
  [formGridClass]="isLandscape() ? 'row-cols-lg-3' : 'row-cols-lg-1'"
  [form]="form()"
  [formSchema]="formSchema()"
  [submitFunc]="submit" />
